import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { ReactComponent as DeleteIcon } from 'assets/icons/Delete.svg';
import { HintField, InputField, LabelField, MyCheckbox, SelectField } from 'components';
import InfoTooltip from 'components/InfoTooltip';
import { getDateFormat, getDateFormatForDatePicket, maskDate } from 'helper/dateFormat';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { toastr } from 'react-redux-toastr';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { getOrganizationInfoFromLocalStorage } from 'utils/functions';
import './DiscountAccordion.scss';
import { fontConfig, fontFamilies } from "theme/fontConfig";
const DiscountAccordion = ({
  summary,
  body,
  formik,
  handleDeleteClick,
  index,
  isExpanded,
  handleExpand,
}) => {
  const orgDetails = getOrganizationInfoFromLocalStorage();
  const dateMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();

  const [maxDate, setMaxDate] = useState('');
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormate || 'mm/dd/yyyy');

  useEffect(() => {
    const currentDate = new Date();
    const maxDate = new Date(
      currentDate.getFullYear() + 100,
      currentDate.getMonth(),
      currentDate.getDate()
    );
    setMaxDate(maxDate.toISOString().slice(0, 10));
  }, []);

  const minDate = moment(Date.now()).format('YYYY-MM-DD');
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    );
    return date;
  }


  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }

  return (
    <div
      className={
        isExpanded
          ? `class_discount_accordion expanded_height`
          : 'class_discount_accordion'
      }
      key={index}
    >
      <Accordion expanded={isExpanded} onChange={handleExpand}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          // aria-controls="panel1a-content"
          // id="panel1a-header"
          className="align-items-center"
        >
          {
            <div className="d-flex align-items-center justify-content-between w-100 accordion_summary">
              {summary}
              <IconButton
                onClick={handleDeleteClick}
                aria-label="delete"
                style={{
                  marginLeft: '-81px',
                  fontFamily: fontFamilies.primary,
                  fontWeight: '400',
                  fontSize: '12px',
                  lineHeight: '18px',
                  color: '#4F4F4F',
                }}
              >
                <DeleteIcon className="mr-3" />
                delete
              </IconButton>
            </div>
          }
        </AccordionSummary>
        <AccordionDetails>
          <div className="w-100">
            <Row style={{ marginBottom: '20px' }}>
              <Col className="col-sm-6">
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                  <label style={{ fontFamily: fontConfig.GeneralLabelFieldFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 }}>Discount Name <span style={{ color: 'red' }}>*</span></label>
                  <InfoTooltip text="A label to identify this discount. E.g., 'Early Bird', 'Sibling Discount'." />
                </div>
                <InputField
                  titleStyle={{
                    fontFamily: fontConfig.GeneralInputFieldFont.family,
                    fontWeight: '400',
                    fontSize: '12px',
                    lineHeight: '18px',
                    color: '#4F4F4F',
                  }}
                  style={{ background: '#FFFFFF' }}
                  formStyle={{ marginBottom: 0 }}
                  mandatory={true}
                  formik={formik}
                  title="none"
                  name={`discount[${index}].discount_name`}
                  placeholder="Discount Name"
                  checkValidation={true}
                  value={formik.values?.discount?.[index]?.discount_name}
                  handleChange={(e) => {
                    const value = e.target.value;
                    if (value.length > 30) return;
                    formik.setFieldValue(`discount[${index}].discount_name`, value);
                    if (!value) {
                      formik.setFieldError(`discount[${index}].discount_name`, 'Required');
                      formik.setFieldTouched(`discount[${index}].discount_name`, true);
                    }
                  }}
                />
              </Col>
              <Col className="col-sm-6">
                <div
                  className="price_radio_group position-relative d-flex justify-content-end"
                  style={{
                    marginBottom: '-30px',
                    zIndex: '999',
                  }}
                >
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    // defaultValue="fixed_price"
                    name="radio-buttons-group"
                    row
                    value={formik.values?.discount?.[index]?.price_type}
                    onChange={(e) =>
                      formik.setFieldValue(
                        `discount[${index}].price_type`,
                        e.target.value
                      )
                    }
                  >
                    <FormControlLabel
                      value="fixed"
                      control={<Radio className="mr-2" />}
                      label="Fixed Price"
                    />
                    <FormControlLabel
                      value="percentage"
                      control={<Radio className="mr-2" />}
                      label="Percentage"
                    />
                  </RadioGroup>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px', position: 'relative', zIndex: 1000 }}>
                  <label style={{ fontFamily: fontConfig.GeneralLabelFieldFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 }}>Value <span style={{ color: 'red' }}>*</span></label>
                  <InfoTooltip text="The discount amount or percentage applied when this discount is used." />
                </div>
                <InputField
                  titleStyle={{
                    fontFamily: fontConfig.GeneralInputFieldFont.family,
                    fontWeight: '400',
                    fontSize: '12px',
                    lineHeight: '18px',
                    color: '#4F4F4F',
                  }}
                  style={{ background: '#FFFFFF' }}
                  formStyle={{ marginBottom: 0 }}
                  mandatory={true}
                  formik={formik}
                  title="none"
                  name={`discount[${index}].value`}
                  placeholder="Value"
                  checkValidation={true}
                  value={formik.values?.discount?.[index]?.value}
                  handleChange={(e) => {
                    const value = e?.target?.value.match(regex)[0];
                    const isPercentage = formik.values?.discount?.[index]?.price_type === 'percentage';
                    const max = isPercentage ? 100 : 10000;
                    if (parseFloat(value) > max) return;
                    formik.setFieldValue(`discount[${index}].value`, value);
                    if (!value) {
                      formik.setFieldError(`discount[${index}].value`, 'Required');
                      formik.setFieldTouched(`discount[${index}].value`, true);
                    }
                  }}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                      event.preventDefault();
                    }
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col className="col-sm-6">
                <SelectField
                  mandatory={true}
                  titleStyle={{
                    fontFamily: fontConfig.GeneralSelectFieldFont.family,
                    fontWeight: '400',
                    fontSize: '12px',
                    lineHeight: '18px',
                    color: '#4F4F4F',
                  }}
                  style={{ background: '#FFFFFF' }}
                  formik={formik}
                  title="Discount Type"
                  name="discount_type"
                  placeholder="Discount Type"
                  checkValidation={true}
                  items={['Date', 'Amount', 'Quantity']}
                  value={formik.values?.discount?.[index]?.discount_type}
                  onClick={(data) => {
                    // if (
                    //   index !== 0 &&
                    //   formik.values?.discount_type &&
                    //   formik.values?.discount_type !== data
                    // ) {
                    //   toastr.info(
                    //     'Validation',
                    //     'The discount type for all discounts must be the same.'
                    //   );
                    //   return;
                    // }
                    formik.setFieldValue(
                      `discount[${index}].discount_type`,
                      data
                    );
                  }}
                />
              </Col>
              {formik.values?.discount?.[
                index
              ]?.discount_type?.toLowerCase() === 'date' && (
                <>
                  <Col className="col-sm-3">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <LabelField title={'Start Date'} mandatory style={{ marginBottom: 0 }} />
                      <InfoTooltip text="The date this discount becomes active." style={{ marginBottom: '8px' }} />
                    </div>
                    <DatePicker
                      isClearable
                      showIcon
                      placeholderText={placeholderFormat}
                      dateFormat={dateFormate}
                      selected={
                        formik.values.discount?.[index]?.start_date &&
                        convertUTCToLocalDate(
                          formik.values.discount?.[index]?.start_date
                        )
                      }
                      onChange={(e) => {
                        if (formik.values.discount?.[index]?.end_date && e > formik.values.discount?.[index]?.end_date) {
                          toastr.info(
                            'Validation',
                            'Start date should be less than end date.'
                          );
                          return;
                        }
                        formik.setFieldValue(`discount[${index}].start_date`, e);
                        convertLocalToUTCDate(e, `discount[${index}].start_date`);
                        if (!e) {
                          formik.setFieldError(`discount[${index}].start_date`, 'Required');
                          formik.setFieldTouched(`discount[${index}].start_date`, true);
                        }
                      }}
                      minDate={new Date()}
                      maxDate={
                        formik.values?.registration_ends 
                      }
                      customInput={
                        <MaskedInput
                          pipe={autoCorrectedDatePipe}
                          mask={dateMask}
                          keepCharPositions={true}
                          guide={true}
                          className={`form-control form-control-solid${formik.touched?.discount?.[index]?.start_date && formik.errors?.discount?.[index]?.start_date ? ' is-invalid' : ''}`}
                        />
                      }
                    />
                    {formik.touched?.discount?.[index]?.start_date && formik.errors?.discount?.[index]?.start_date && (
                      <HintField error={formik.errors.discount[index].start_date} />
                    )}
                  </Col>
                  <Col className="col-sm-3">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <LabelField title={'End Date'} mandatory style={{ marginBottom: 0 }} />
                      <InfoTooltip text="The date this discount stops applying." style={{ marginBottom: '8px' }} />
                    </div>
                    <DatePicker
                      isClearable
                      showIcon
                      placeholderText={placeholderFormat}
                      dateFormat={dateFormate}
                      selected={
                        formik.values.discount?.[index]?.end_date &&
                        convertUTCToLocalDate(
                          formik.values.discount?.[index]?.end_date
                        )
                      }
                      onChange={(e) => {
                        formik.setFieldValue(`discount[${index}].end_date`, e);
                        convertLocalToUTCDate(e, `discount[${index}].end_date`);
                        if (!e) {
                          formik.setFieldError(`discount[${index}].end_date`, 'Required');
                          formik.setFieldTouched(`discount[${index}].end_date`, true);
                        }
                      }}
                      minDate={
                        formik.values.discount?.[index]?.start_date ||
                        new Date()
                      }
                      customInput={
                        <MaskedInput
                          pipe={autoCorrectedDatePipe}
                          mask={dateMask}
                          keepCharPositions={true}
                          guide={true}
                          className={`form-control form-control-solid${formik.touched?.discount?.[index]?.end_date && formik.errors?.discount?.[index]?.end_date ? ' is-invalid' : ''}`}
                        />
                      }
                    />
                    {formik.touched?.discount?.[index]?.end_date && formik.errors?.discount?.[index]?.end_date && (
                      <HintField error={formik.errors.discount[index].end_date} />
                    )}
                  </Col>
                </>
              )}
              {formik.values?.discount?.[
                index
              ]?.discount_type?.toLowerCase() === 'quantity' && (
                <Col className="col-sm-6">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                    <label style={{ fontFamily: fontConfig.GeneralLabelFieldFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 }}>Quantity <span style={{ color: 'red' }}>*</span></label>
                    <InfoTooltip text="The number of items that must be selected for this discount to apply." />
                  </div>
                  <InputField
                    titleStyle={{
                      fontFamily: fontConfig.GeneralInputFieldFont.family,
                      fontWeight: '400',
                      fontSize: '12px',
                      lineHeight: '18px',
                      color: '#4F4F4F',
                    }}
                    style={{ background: '#FFFFFF' }}
                    formStyle={{ marginBottom: 0 }}
                    mandatory={true}
                    formik={formik}
                    title="none"
                    name={`discount[${index}].quantity`}
                    placeholder="Quantity"
                    checkValidation={true}
                    value={formik.values?.discount?.[index]?.quantity}
                    handleChange={(e) => {
                      const value = e?.target?.value.match(regex)[0];
                      formik.setFieldValue(`discount[${index}].quantity`, value);
                      if (!value) {
                        formik.setFieldError(`discount[${index}].quantity`, 'Required');
                        formik.setFieldTouched(`discount[${index}].quantity`, true);
                      }
                    }}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        event.preventDefault();
                      }
                    }}
                  />
                </Col>
              )}
                  {formik.values?.discount?.[
                index
              ]?.discount_type?.toLowerCase() === 'amount' && (
                <Col className="col-sm-6">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                    <label style={{ fontFamily: fontConfig.GeneralLabelFieldFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 }}>Amount <span style={{ color: 'red' }}>*</span></label>
                    <InfoTooltip text="The total amount that must be reached for this discount to apply." />
                  </div>
                  <InputField
                    titleStyle={{
                      fontFamily: fontConfig.GeneralInputFieldFont.family,
                      fontWeight: '400',
                      fontSize: '12px',
                      lineHeight: '18px',
                      color: '#4F4F4F',
                    }}
                    style={{ background: '#FFFFFF' }}
                    formStyle={{ marginBottom: 0 }}
                    mandatory={true}
                    formik={formik}
                    title="none"
                    name={`discount[${index}].amount`}
                    placeholder="Amount"
                    checkValidation={true}
                    value={formik.values?.discount?.[index]?.amount}
                    handleChange={(e) => {
                      const value = e?.target?.value.match(regex)[0];
                      formik.setFieldValue(`discount[${index}].amount`, value);
                      if (!value) {
                        formik.setFieldError(`discount[${index}].amount`, 'Required');
                        formik.setFieldTouched(`discount[${index}].amount`, true);
                      }
                    }}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        event.preventDefault();
                      }
                    }}
                  />
                </Col>
              )}
            </Row>
            {(orgDetails?.memberPortal && formik?.values?.allow_non_members_register) && (
            <Row className="mb-5">
              <Col className="col-sm-6 member-only-discount">
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <MyCheckbox
                    title="Members only"
                    name="forMemberOnly"
                    handlechange={(e) => {
                      formik.setFieldValue(
                        `discount[${index}].forMemberOnly`,
                        e.target.checked
                      );
                    }}
                    checked={formik.values?.discount?.[index]?.forMemberOnly}
                    boxBgColor={"#FFFFFF"}
                  />
                  <InfoTooltip text="Restrict this discount to members only. Require users to log in before it can be redeemed." style={{ marginBottom: '8px' }} />
                </div>
              </Col>
            </Row>
            )}
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default DiscountAccordion;
